import React, {
	useEffect, useMemo, useState,
} from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../stores/types/types';

interface SpotlightConnectorProps {
    uniqueSpotlightId: string,
    children?: React.ReactNode;
	mediaId?: number;
}

const SpotlightConnector: React.FC<SpotlightConnectorProps> = ({
	uniqueSpotlightId,
	children,
	mediaId,
}) => {
	const [container, setContainer] = useState<HTMLDivElement | HTMLElement |null>(null);
	const spotlightId = `spotlight-${uniqueSpotlightId}`;
	const clearShot = useSelector((state: GreenroomState) => state.SettingsReducer.clearShot);

	const findContainer = () => {
		const createdDiv = document.getElementById(spotlightId);
		if (createdDiv) {
			setContainer(createdDiv);
		} else {
			setTimeout(findContainer, 10);
		}
	};

	useEffect(
		() => { findContainer() },
		[spotlightId, clearShot],
	);
	const theChildren = useMemo(
		() => container ? ReactDOM.createPortal(children, container as HTMLDivElement) : null,
		[container]
	);

	return (<>{theChildren}</>);
};

export default SpotlightConnector;
